module.exports = __webpack_public_path__ + "media/application/images/ui/icon-youtube-9770c6ba0c8d0e889451abbf4c915381.png";